module.exports = __webpack_public_path__ + "static/img/info_lighting.d43d7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/info_lighting.png
// module id = VGGS
// module chunks = 0